import {
  getChainsList,
  getDeleteSessionsResponse,
  getLocalSessionsState,
  getNewSessionsResponse,
  getRobotListBaldur,
  getRobotsList,
  getScheduleSessions,
  getSessionHistoryList,
  getSessionUpdateResponse,
  isDeletingSessions,
  isLoadingBucketMapLayout,
  isLoadingChains,
  isLoadingNewSessions,
  isLoadingRobotLayout,
  isLoadingRobotListBaldur,
  isLoadingRobots,
  isLoadingRobotSessions,
  isLoadingSessionHistory,
  isLoadingSessionsState,
  isLoadingSessionUpdate,
  navigationOptions
} from 'core/selectors';
import { getChains, getRobots } from 'core/slices/backend';
import { getSessionHistory, getSessionsScheduler } from 'core/slices/baldur/scheduler';
import { getRobotsBaldur, postSessionUpdates } from 'core/slices/fleetControl';
import {
  deleteSessions
} from 'core/slices/scheduler';
import { getSessionsState } from 'core/slices/session';
import { connect } from 'react-redux';
import Scheduler from '../../../components/fleetManagement/Scheduler';

export default connect(state => ({
  chainsList: getChainsList(state),
  robotsList: getRobotsList(state),
  robotsListBaldur: getRobotListBaldur(state),
  sessionsList: getScheduleSessions(state),
  isLoadingSessions: isLoadingRobotSessions(state),
  newSessionsResponse: getNewSessionsResponse(state),
  isLoadingChains: isLoadingChains(state),
  isLoadingRobots: isLoadingRobots(state),
  isLoadingRobotListBaldur: isLoadingRobotListBaldur(state),
  isLoadingNewSessions: isLoadingNewSessions(state),
  navOptions: navigationOptions(state),
  isLoadingSessionUpdate: isLoadingSessionUpdate(state),
  updateSessionResponse: getSessionUpdateResponse(state),
  isLoadingDeleteSessions: isDeletingSessions(state),
  deleteSessionsResponse: getDeleteSessionsResponse(state),
  isLoadingSessionsState: isLoadingSessionsState(state),
  sessionsState: getLocalSessionsState(state),
  isLoadingRobotLayout: isLoadingRobotLayout(state),
  isLoadingBucketMapLayout: isLoadingBucketMapLayout(state),
  isLoadingSessionHistory: isLoadingSessionHistory(state),
  sessionHistory: getSessionHistoryList(state),
}),
  {
    getChains,
    getRobots,
    getRobotsBaldur,
    getSessionsScheduler,
    postSessionUpdates,
    deleteSessions,
    getSessionsState,
    getSessionHistory,
  },)(Scheduler);